import React, { useRef, useEffect, useState } from 'react';
import _ from 'lodash';
import classnames from 'classnames/bind';
import style from './index.module.scss';
import Rating from '../Rating';
import OilThumb from '../OilThumb';
import { IProd, IState, ProductCategory, Replacement } from '../../interface';
import localesReplacement from '../../utils/localesReplacement';
import { connect } from 'react-redux';
import DOMPurify from 'dompurify';

const cx = classnames.bind(style);

export interface IProps {
  dataList: Partial<IProd>;
  withoutMoreLink: boolean;
  replacements: Replacement;
  moreLinkClick?: () => void;
  productCategories: ProductCategory[];
  openModalHandle?: () => void;
  withTitle?: boolean;
  vehicle?:any;
  products?:any;
  componentName?:any;
  onPrintClick?: any;
}

export const OilBaseInfomation = (props: IProps) => {
  const {
    withoutMoreLink,
    dataList,
    replacements,
    moreLinkClick,
    openModalHandle,
    withTitle,
    vehicle,
    componentName,
    onPrintClick
  } = props;
  const window: any = globalThis;
  window.dataLayer = window.dataLayer || [];
  const [textOverflow, setTextOverflow] = useState<boolean>(false);
  const [textExpanded, setTextExpanded] = useState<boolean>(false);

  const ref = useRef<HTMLDivElement>(null);
  const readMoreDataLayer=()=>{
    window.dataLayer.push({
      'event': 'readRecommendedProductClick',
      'pageType' : 'recommended oils',
      'recommendationType' : 'alternative recommendation',
      'buttonName' : 'read',
      'oilName' : dataList?.name,
      'oilCategory' : componentName,
      'vehicleModel' : `${vehicle?.make} ${vehicle?.model}`,
      'countryCode' :localStorage.getItem('countryCode')
    })
  }
  useEffect(() => {
    const elem: any = ref?.current;
    if (elem && elem.scrollHeight > elem.clientHeight) {
      setTextOverflow(true);
    } else {
      setTextOverflow(false);
    }
  }, []);

  return (
    <div
      className={`oil-base ${cx('block')} ${cx(withTitle ? 'without-title' : '')}`}
    >
      {!withTitle && <h4 className={cx('name')}>{dataList['name']}</h4>}
      <div className={cx('meta')}>
        <div className={cx('rating')}>
          <Rating dataList={_.get(dataList, 'rating') || 4.2} />
        </div>
        <span className={cx('reviews')}>
          ({_.get(dataList, 'reviews')}{' '}
          {localesReplacement(replacements, 'reviews')})
        </span>
      </div>
      <div className={cx('thumb')}>
        <OilThumb
          withoutMoreLink={withoutMoreLink}
          dataList={dataList}
          moreLinkClick={moreLinkClick}
          onPrintClick={onPrintClick}
        />
      </div>
      <div
        ref={ref}
        className={`${cx('desc')} ${textExpanded ? cx('no-clamp') : cx('clamp')}`}
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(_.get(dataList, 'description') || ''),
        }}
      ></div>
      {openModalHandle && (
        <span
          className="primary-link read-more"
          role="link"
          onClick={() => {
            openModalHandle();
            readMoreDataLayer();
          }}
        >
          {localesReplacement(replacements, 'Read more')}
        </span>
      )}
      {!openModalHandle && textOverflow && (
        <span
          className={`primary-link ${cx('read-more')}`}
          role="link"
          onClick={() => {
            const elem: any = ref?.current;
            if (!textExpanded) {
              elem.style.height = `${elem.scrollHeight}px`;
              elem.style.maxHeight = `${elem.scrollHeight}px`
              setTimeout(() => {
                elem.style.height = `${elem.scrollHeight}px`;
                elem.style.maxHeight = `${elem.scrollHeight}px`;
              }, 0)
              setTextExpanded(true);
            } else {
              elem.style.removeProperty('max-height');
              elem.style.removeProperty('height');
              setTextExpanded(false);
            }
          }}
        >
          {localesReplacement(
            replacements,
            !textExpanded ? 'Read more' : 'Read less'
          )}
        </span>
      )}
    </div>
  );
};

const mapStateToProps = (state: IState) => ({
  replacements: state.replacements,
});

export default connect(mapStateToProps)(OilBaseInfomation);
